import { checkPermission } from '@vision/ui/utils';
import { useMemo } from 'react';
import { usePermissions } from './usePermissions';

export function useCheckPermission(permissionKey: string | string[]): boolean {
  const userPermissions = usePermissions();

  return useMemo(() => {
    const permissionKeys = Array.isArray(permissionKey) ? permissionKey : [permissionKey];
    return permissionKeys.some((key) => checkPermission(key, userPermissions));
  }, [permissionKey, userPermissions]);
}
